import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const FilePencil = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 32 32" ref={ref} {...props}>
      <path d="M6.4 0h12.8l9.6 9.6v19.2c0 1.76-1.44 3.2-3.2 3.2H6.384C4.624 32 3.2 30.56 3.2 28.8l.016-25.6C3.216 1.44 4.64 0 6.4 0zm3.2 24.565V27.2h2.635l7.349-7.328a.528.528 0 0 0 0-.757l-1.888-1.888a.528.528 0 0 0-.757 0L9.6 24.566zM22.4 27.2v-2.133h-5.867L14.4 27.2h8zM17.6 2.4v8.8h8.8l-8.8-8.8z"/>
    </SvgIcon>
  );
});

FilePencil.displayName = "FilePencil";

export default FilePencil;
